@let control = $control();
<unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  @let showSpinners = $spinners() && control && control.enabled;
  <kendo-numerictextbox
    format="c2"
    [decimals]="2"
    [spinners]="showSpinners"
    [step]="$spinnerStep()"
    [formControl]="control"
    [title]="control.value" />
</unity-control-wrapper>
